export default __webpack_public_path__ + "images/FTO.9e0010f.png";